<template>
  <Admin>
    <v-main>
      <v-container fluid>
        <v-row justify="center">
          <v-col>
            <downloaded-table></downloaded-table>
          </v-col>
        </v-row>
        <v-row justify="start">
          <v-col>
            <pagination collection-name="docsDownloadedByCompany"></pagination>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </Admin>
</template>

<script>
import Admin from '../../components/admin/admin-main-template'
import DownloadedTable from '../../components/admin/downloaded/table'
import Pagination from '../../components/admin/pagination'

export default {
  name: 'Document',
  components: {
    Admin,
    DownloadedTable,
    Pagination
  }
}
</script>
